
define('text!areas/home/views/help.html',[],function () { return '<section id="help" class="pull-fullheight">\r\n\r\n\t<div class="panel-heading">\r\n\t\tHilfe\r\n\t</div>\r\n\r\n\t<div class="panel-body" data-i18n="app:modules.home.info_help">\r\n\t\tDie Onlinehilfe zu ADDISON OneClick steht Ihnen in einem separaten Tab Ihres Browsers zur Verfügung\t\t\r\n\t</div>\r\n</section>';});

